import React from "react";
import "../paymentTerms/PaymentTerms.scss";
import useForm from "./useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import PaymentTermsForm from "../../components/paymentTerms/PaymentTermsForm";

const AddPaymentTerms = () => {
  const {
    values,
    setValues,
    handleFormChange,
    handleSubmit,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    errors,
    errorShow,
    ErrorDoneClick,
    SuccessDoneClick,
  } = useForm();

  return (
    <>
      <div className="container-fluid add-payment-terms-sec">
        {/* <!-- add-new-sec starts --> */}
        <PaymentTermsForm
          handleFormChange={handleFormChange}
          errors={errors}
          values={values}
          setValues={setValues}
          handleSubmit={handleSubmit}
        />

        {/* <!-- add-new-sec ends --> */}
      </div>
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
    </>
  );
};

export default AddPaymentTerms;
